// shortcodes via https://emojipedia.org/

const hugging_face = require('emojione/assets/svg/1f917.svg');
const money_bag = require('emojione/assets/svg/1f4b0.svg');
const question_mark = require('emojione/assets/svg/2753.svg');
const raising_hands = require('emojione/assets/svg/1f64c.svg');
const rocket = require('emojione/assets/svg/1f680.svg');

const flag_brazil = require('emojione/assets/svg/1f1e7-1f1f7.svg');
const flag_china = require('emojione/assets/svg/1f1e8-1f1f3.svg');
const flag_eurounion = require('emojione/assets/svg/1f1ea-1f1fa.svg');
const flag_malaysia = require('emojione/assets/svg/1f1f2-1f1fe.svg');
const flag_poland = require('emojione/assets/svg/1f1f5-1f1f1.svg');
const flag_russia = require('emojione/assets/svg/1f1f7-1f1fa.svg');
const flag_spain = require('emojione/assets/svg/1f1ea-1f1f8.svg');
const flag_united_states = require('emojione/assets/svg/1f1fa-1f1f8.svg');
const flag_vietnam = require('emojione/assets/svg/1f1fb-1f1f3.svg');
const flag_ukraine = require('emojione/assets/svg/1f1fa-1f1e6.svg');
const flag_kazakhstan = require('emojione/assets/svg/1f1f0-1f1ff.svg');
const flag_united_kingdom = require('emojione/assets/svg/1f1ec-1f1e7.svg');
const flag_mexico = require('emojione/assets/svg/1f1f2-1f1fd.svg');
const flag_indonesia = require('emojione/assets/svg/1f1ee-1f1e9.svg');

export {
  hugging_face,
  money_bag,
  question_mark,
  raising_hands,
  rocket,

  flag_brazil,
  flag_china,
  flag_eurounion,
  flag_malaysia,
  flag_poland,
  flag_russia,
  flag_spain,
  flag_united_states,
  flag_vietnam,

  flag_ukraine,
  flag_kazakhstan,
  flag_united_kingdom,
  flag_mexico,
  flag_indonesia,

  question_mark as default,
};
